const initState = {
    base: null,
    server: null,
    isDevelopmentMode: true
}

const domainReducer = (state = initState, action) => {
    if ((window.location.host.split(":")[0] === "localhost")) {
        state.base = "http://" + window.location.host;
        state.server = "nodejs";
        state.isDevelopmentMode = true;
    } else {
        state.base = "http://" + window.location.host + ":80/";
        state.server = "apache-php";
        state.isDevelopmentMode = false;
    }

    return state;
};

export default domainReducer;